import React from 'react';
import { useDispatch } from 'react-redux';

import { toastSuccess } from '@components/Toast';

import { setPinnedCollection, setUnPinnedCollection } from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

const CollectionPinUnpin = ({ collection }) => {
	const dispatch = useDispatch();

	const onPinClick = async (id) => {
		try {
			dispatch(openLoader());
			const { data } = await ApiClient.POST('pinCollection', {}, `${id}/pin`);
			toastSuccess(data.message);
			dispatch(setPinnedCollection(id));
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const onUnPinClick = async (id) => {
		try {
			dispatch(openLoader());
			const { data } = await ApiClient.POST('pinCollection', {}, `${id}/unpin`);
			toastSuccess(data.message);
			dispatch(setUnPinnedCollection(id));
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	return (
		<>
			{collection?.isPinned ? (
				<div
					className="pin pinned"
					onClick={(e) => {
						e.stopPropagation();
						onUnPinClick(collection.id);
					}}
				>
					<img src={`${process.env.PUBLIC_URL}/icons/Pinned-dark-with-bg.svg`} alt="pin" />
				</div>
			) : (
				<div
					className="pin"
					onClick={(e) => {
						e.stopPropagation();
						onPinClick(collection.id);
					}}
				>
					<img src={`${process.env.PUBLIC_URL}/icons/Pin-dark-with-bg.svg`} alt="pin" />
				</div>
			)}
		</>
	);
};

export default CollectionPinUnpin;
